import { useTheme } from '@mui/material';

import { OneIcon, TwoIcon, ThreeIcon } from '@rumblefish/ui/Rumblefish23Theme';

export const BenefitsData = () => {
  const theme = useTheme();
  return [
    {
      name: 'confidence_and_trust',
      icon: OneIcon,
      title: 'Confidence & trust',
      boxShadow: theme.mixins.orangeGradientTransparent?.boxShadow || '',
      duration: 4,
      floatingY: 7.4,
      description:
        'By working with Rumble Fish you’ll acquire a long-term and trustworthy technology partner to help you with all of your digital endeavors. Our extensive knowledge and battle-tested solutions let us craft the most powerful products with great confidence.',
    },
    {
      name: 'quality_and_security',
      icon: TwoIcon,
      title: 'Quality & security',
      boxShadow: theme.mixins.redGradientTransparent?.boxShadow || '',
      duration: 5,
      floatingY: 3,
      description:
        'Top quality translates into secure products. We believe in the value of this symbiotic relationship, ensuring software can fulfill its ultimate business function of satisfying and protecting the customer in equal measure.',
    },
    {
      name: 'technology_and_design',
      icon: ThreeIcon,
      title: 'Top-notch technology & design',
      boxShadow: theme.mixins.magentaGradientTransparent?.boxShadow || '',
      duration: 2,
      floatingY: 4.5,
      description:
        'Our development teams use the serverless framework extensively, combining it with automation solutions such as Gitlab CI, AWS Code Build, or Docker. We follow the Infrastructure as Code (IaC) principle that ensures the high maintainability of our solutions.',
    },
  ];
};
